import { useLanguage } from "@/contexts/LanguageContext";

const Footer = () => {
  const { t, isRTL } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="relative bg-ink border-t border-white/5">
      <div className="container-x py-14 grid grid-cols-1 md:grid-cols-3 gap-8 items-center">
        <div>
          <div className={`${isRTL ? "font-arabic font-bold" : "font-serif italic"} text-bone text-xl tracking-[0.1em]`}>
            {t.brand.name}
          </div>
          {t.footer.tagline ? (
            <div className={`mt-2 text-xs tracking-[0.2em] uppercase text-white/40 ${isRTL ? "font-arabic tracking-normal text-sm" : ""}`}>
              {t.footer.tagline}
            </div>
          ) : null}
        </div>

        <div className="text-center text-xs tracking-[0.2em] uppercase text-white/40">
          © {year} · {t.footer.rights}
        </div>

        {t.footer.builtFor ? (
          <div className={`text-xs tracking-[0.2em] uppercase text-white/40 ${isRTL ? "md:text-left font-arabic tracking-normal text-sm" : "md:text-right"}`}>
            {t.footer.builtFor}
          </div>
        ) : (
          <div />
        )}
      </div>
      <div className="h-px gold-rule" />
    </footer>
  );
};

export default Footer;
